import React, { Component } from 'react'
import QrReader from 'react-qr-reader';
import AlertComponent from '../Common/Alert/Alert';
import Header from '../Common/Header/Header';
import { HttpService } from '../service/HttpService';
import './scanner.css'
import logo from '../../src/assets/images/logo1.png'
import StarBorderIcon from '@material-ui/icons/StarBorder';
import { Input, Button } from 'reactstrap';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
class QrContainer extends Component {
  constructor(props) {
    super(props)
    // if(this.props.location==undefined || this.props.location.state==undefined){
    //     this.props.history.goBack();        }
    this.state = {
      result: {},
      role: '',
      color: '',
      message: '',
      alert: false,
      code: '',
      hasPermission: false,
    }


    this.handleScan = this.handleScan.bind(this)
    this.httpService = new HttpService();

  }

  componentDidMount() {
    this.getUserInfo();
    this.handleCameraPermission();
  }

  handleCameraPermission = async () => {
    console.log("In")
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: false,
      });
      this.setState({ hasPermission: true })
      // Do something with the stream, such as displaying it on a video element
    } catch (err) {
      console.log(err);
    }
  };



  onDismiss = () => {
    this.setState({ alert: false })
  }


  getUserInfo = () => {
    var obj = {};
    if (localStorage.getItem('user') !== undefined && localStorage.getItem('user') !== null) {
      obj = JSON.parse(localStorage.getItem('user'));
      this.setState({ 'role': obj.authorities[0] })

    }
  }

  saveRewardPoints = (points, rewardedFor) => {
    this.httpService.postApi1('userRewardHistory', { "rewardPoint": points, "rewardedFor": rewardedFor }).then((response) => {
      console.log(response)

      if (this.state.role !== 'ROLE_VOUCHER_ADMIN') {
        this.props.history.push({
          pathname: '/rewards',
          state: { points: response.data.rewardPoint }
        })
      } else {
        this.setState({ alert: true, message: 'Redeem Done Successfully', color: 'info' })
        this.props.history.push({
          pathname: '/transactions'
        })
      }

    }, (error) => {
      console.log(error);
      const errMessage = error.response.data
      this.setState({ color: 'danger', message: errMessage.message, alert: true })
    });
  }

  setCodeValue = (code) => {
    this.setState({ code: code });
    if (code.length == 6) {

      var id = 'REVM000' + code.substring(1, 3)
      var userId = 'USER000' + code.substring(4, 6)
      let data = { "id": id, "userId": userId }

      this.handleScan(data)
      console.log(data)
    }
  }

  handleScan = data => {

    if (data) {

      let request = {};
      let url = '';
      let result = {}
      if (this.state.code != '' && this.state.role == "ROLE_VOUCHER_ADMIN")
        result = data
      else
        result = JSON.parse(data)
      let rewardedFor = ''
      console.log("result" + result)

      if (this.state.role == 'ROLE_VOUCHER_ADMIN') {
        url = 'userRedeemHistory'
        let user = {}
        user.userId = result.userId
        request = { type: "Voucher", redeemVoucherMaster: { id: result.id }, user: { userId: result.userId } }
        rewardedFor = result.userId

      } else {

        url = 'rvm/transaction/statechange'
        request = { "transactioncode": result.transactioncode, "iddevice": result.iddevice, "apikey": "123456789" }
        rewardedFor = 'scanning'
      }



      console.log(request)


      this.httpService.postApi1(url, request).then((response) => {
        let points = ''
        if (this.state.role == 'ROLE_VOUCHER_ADMIN')
          points = response.data.amount
        else
          points = response.data.points
        this.saveRewardPoints(points, rewardedFor)

      }, (error) => {
        const errMessage = error.response.data
        this.setState({ color: 'danger', message: errMessage.message, alert: true })
      });


    }

  }
  handleError = err => {
    console.error(err)
  }

  redirect = (view) => {
    this.props.history.push({
      pathname: view
    })
  }



  render() {



    return <div className="mainSection" style={{ backgroundColor: '#c94d3d' }}>
      <div style={{ backgroundColor: '#c94d3d' }}>
        <div className="scanSection1">

          <div style={{ flexDirection: 'row', display: 'flex', padding: '10px', justifyContent: 'space-between' }}>
            <ArrowBackIosIcon onClick={() => this.redirect('/home')} />
            <p style={{ color: '#c94d3d', fontWeight: '700' }}>{this.state.role != 'ROLE_VOUCHER_ADMIN' ? <>Upload Points</> : <>Validate</>}  <StarBorderIcon style={{ top: '-10px' }} /></p>
          </div>
          {this.state.alert &&
            <AlertComponent color={this.state.color} message={this.state.message} alert={this.state.alert} onDismiss={this.onDismiss} />
          }
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>

            <QrReader
              delay={300}
              onError={this.handleError}
              onScan={this.handleScan}
              className="scanner"

            />


          </div>

          <div style={{
            padding: "20px",
            textAlign: "center",
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            {this.state.role !== 'ROLE_VOUCHER_ADMIN' ?
              <>Please scan the QR code on screen to collect your rewards.</> : <><h5 style={{ color: '#c94d3d' }}>OR</h5>    <Input type="text" maxLength={6} name="name" placeholder="Type Qr Label" className="codeInput" rules={{ required: { value: true, message: "This field is required" }, maxLength: { value: 25, message: "Value must be less then 25" } }} onChange={(event) => { this.setCodeValue(event.target.value) }}  >  </Input> </>
            }
          </div>

        </div>
      </div>

      <div style={{ backgroundColor: '#32e8d8' }}>
        <div className="scanSection2" style={{ color: 'white' }}>

          <div style={{ textAlign: 'center' }}>

            {this.state.role !== 'ROLE_VOUCHER_ADMIN' ? <p > Thank you for Recycling </p> : <p>Accept Redemption</p>}
            <img className="footer_logo" src={logo} alt="logo" /></div>
        </div>
      </div>
    </div>

  }
}

export default QrContainer;